import { render, staticRenderFns } from "./En.vue?vue&type=template&id=0c12f996&scoped=true&"
var script = {}
import style0 from "./En.vue?vue&type=style&index=0&id=0c12f996&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c12f996",
  null
  
)

export default component.exports